'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.43592 7.30841C0.933385 7.74049 0.876266 8.49814 1.30834 9.00067L10.3704 19.5405C10.3805 19.5523 10.3908 19.5643 10.4013 19.5765C10.5489 19.7484 10.7316 19.9613 10.9141 20.1214C11.1351 20.3153 11.5095 20.5732 12.0386 20.5732C12.5677 20.5732 12.9421 20.3153 13.163 20.1215C13.3456 19.9613 13.5283 19.7484 13.6759 19.5765C13.6864 19.5643 13.6967 19.5523 13.7068 19.5406L22.6913 9.09114C23.1233 8.58861 23.0662 7.83097 22.5637 7.39889C22.0612 6.96681 21.3035 7.02392 20.8714 7.52645L12.0386 17.7995L3.12817 7.43599C2.6961 6.93346 1.93845 6.87634 1.43592 7.30841Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
